/**
 * Auth Context
 * Manages global authentication state — token, user, org
 */

import React, { createContext, useContext, useState, useCallback } from "react";

const AuthContext = createContext(null);

const SESSION_KEYS = {
  AUTH: "auth",
  USER: "user",
  ORG: "org",
};

export const AuthProvider = ({ children }) => {
  const [isAuth, setIsAuthState] = useState(
    () => !!localStorage.getItem(SESSION_KEYS.AUTH)
  );

  const login = useCallback((credentials, userData, orgData) => {
    localStorage.setItem(SESSION_KEYS.AUTH, credentials.access_token);
    localStorage.setItem(SESSION_KEYS.USER, JSON.stringify(userData));
    localStorage.setItem(SESSION_KEYS.ORG, JSON.stringify(orgData));
    setIsAuthState(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.clear();
    setIsAuthState(false);
  }, []);

  const getUser = useCallback(
    () => JSON.parse(localStorage.getItem(SESSION_KEYS.USER) || "{}"),
    []
  );

  const getOrg = useCallback(
    () => JSON.parse(localStorage.getItem(SESSION_KEYS.ORG) || "{}"),
    []
  );

  return (
    <AuthContext.Provider value={{ isAuth, login, logout, getUser, getOrg }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};